export async function tryWithRetry<T>(fn: () => Promise<T>, count: number) {
  try {
    return await fn();
  } catch (e) {
    if (count > 1) {
      return tryWithRetry(fn, count - 1);
    }
    throw e;
  }
}
